<ng-container>
    <h2 mat-dialog-title class="m-0 mb-8">Incidencia</h2>

    @if (inc()) {
        <div style="width: 60vh" class="p-12">
            <div fxLayout="row " class="p-4">
                @if (inc().username) {
                    <div fxLayout="column" fxLayoutAlign="center center" class="p-2 imagen-cont">
                        <div class="person-avatar avatar-perfil">
                            <img class="img-circle" [src]="getImageUser(inc().username)" />
                        </div>
                    </div>
                }
                <div fxLayout="column" fxLayoutAlign="center center" class="p-2">
                    @if (inc().displayName) {
                        <h5 style="font-size: 18px" class="mt-4 mb-4">{{ inc().displayName }}</h5>
                    }
                </div>
            </div>
            <div fxLayout="row " class="p-3" fxLayoutAlign="center center">
                <div fxLayout="column" fxLayoutAlign="center center">
                    @if (inc().tipo == 0) {
                        <b class="icon-badgeM" style="font-size: 22px">Baja médica</b>
                    }
                    @if (inc().tipo == 3) {
                        <b class="icon-badgeM" style="font-size: 22px">Asistencia a médico</b>
                    }
                    @if (inc().tipo == 1) {
                        <b class="icon-badgeO" style="font-size: 22px">Otra</b>
                    }
                    @if (inc().tipo == 4) {
                        <b class="icon-badgeO" style="font-size: 22px">Asistencia a juicio</b>
                    }
                    @if (inc().tipo == 5) {
                        <b class="icon-badgeO" style="font-size: 22px">Asistencia examen oficial</b>
                    }
                    @if (inc().tipo == 9) {
                        <b class="icon-badgeO" style="font-size: 22px">Ausencia / Permiso retribuido</b>
                    }
                    @if (inc().tipo == 7) {
                        <b class="icon-badgeO" style="font-size: 22px">Horas sindicales</b>
                    }
                    @if (inc().tipo == 6) {
                        <b class="icon-badgeO" style="font-size: 22px">Maternidad/Paternidad</b>
                    }
                </div>
            </div>
            <div fxLayout="row " fxLayoutAlign="start start" class="p-8">
                <div fxLayout="column" fxLayoutAlign="start start" fxFlex="2 1 0" class="p-4 w-100-p">
                    <div fxLayout="row" fxLayoutAlign="start start" class="w-100-p">
                        <span style="font-size: 16px">Motivo</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start start" class="w-100-p">
                        <div
                            fxLayout="column"
                            fxLayoutAlign="start start"
                            style="
                                background-color: rgb(217, 217, 217);
                                border: 1px solid gray;
                                padding: 8px;
                                border-radius: 5px;
                                width: 100%;
                            "
                        >
                            <span style="font-style: italic; width: 100%">{{
                                inc()?.motivo ?? "No hay motivo registrado"
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div fxLayout="row " fxLayoutAlign="start start" class="p-8">
                <div fxLayout="column" fxLayoutAlign="start start" fxFlex="2 1 0" class="p-4 w-100-p">
                    <div fxLayout="row" fxLayoutAlign="start start" class="w-100-p">
                        <span style="font-size: 16px">Fecha de inicio</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start start" class="w-100-p">
                        <div
                            fxLayout="column"
                            fxLayoutAlign="start start"
                            style="
                                background-color: rgb(217, 217, 217);
                                border: 1px solid gray;
                                padding: 8px;
                                border-radius: 5px;
                                width: 100%;
                            "
                        >
                            <span style="font-style: italic; width: 100%"
                                >{{ inc().fecha_ini }}{{ projectConfig?.id == 472 ? " - " + inc().hora_ini : "" }}</span
                            >
                        </div>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start" fxFlex="2 1 0" class="p-4 w-100-p">
                    <div fxLayout="row" fxLayoutAlign="start start" class="w-100-p">
                        <span style="font-size: 16px">Fecha de fin</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start start" class="w-100-p">
                        <div
                            fxLayout="column"
                            fxLayoutAlign="start start"
                            style="
                                background-color: rgb(217, 217, 217);
                                border: 1px solid gray;
                                padding: 8px;
                                border-radius: 5px;
                                width: 100%;
                            "
                        >
                            <span style="font-style: italic; width: 100%"
                                >{{ inc().fecha_fin }}{{ projectConfig?.id == 472 ? " - " + inc().hora_fin : "" }}</span
                            >
                        </div>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start" fxFlex="1 1 0" class="p-4 w-100-p"></div>
                <div fxLayout="column" fxLayoutAlign="start start" fxFlex="1 1 0" class="p-4 w-100-p">
                    <div fxLayout="row" fxLayoutAlign="start start" class="w-100-p">
                        <span style="font-size: 16px">Justificante</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start start" class="w-100-p">
                        @if (inc().archivo !== "") {
                            <span style="font-size: 16px; padding: 8px">✅</span>
                        } @else {
                            <span style="font-size: 16px; padding: 8px">❌</span>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
    @if (!inc) {
        <div style="width: 60vh" class="p-12">
            <div fxLayout="row " class="p-4">
                <div fxLayout="column" fxLayoutAlign="center center" class="p-2 imagen-cont">
                    <span style="font-style: italic; width: 100%">No se ha podido encontrar esta incidencia</span>
                </div>
            </div>
        </div>
    }
</ng-container>
